module.exports = __webpack_public_path__ + "static/media/welcome-banner.e9109d78.png";